import axios from "axios";

export const getVisitors = (query = null) => {
    return axios.get(`visitors${query ? ('?' + new URLSearchParams(query).toString()) : ''}`)
}